export default function OutcomeChipGrid({ outcomes, value, onChange }) {
  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
      {outcomes.map((o) => (
        <button
          key={o.value}
          type="button"
          onClick={() => onChange(o.value)}
          className={`rounded-lg px-3 py-2 text-xs font-semibold transition-all ${
            o.color || "bg-gray-100 text-gray-700"
          } ${
            o.value === value
              ? "ring-2 ring-navy ring-offset-1"
              : "opacity-70 hover:opacity-100"
          }`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
